import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el libro y cuándo puedo empezar a leerlo?',
  answer: 'Es un PDF de alta calidad que recibes de forma inmediata después del pago. Lo puedes abrir en tu teléfono, tablet o computadora en menos de 2 minutos. Recibes 4 PDFs en total: el libro principal y los 3 bonos exclusivos.'
}, {
  question: '¿Puedo leerlo aunque ya esté bajo tratamiento médico?',
  answer: 'Sí. Este libro es educativo, no médico. No reemplaza tu tratamiento ni a tu médico — lo complementa. De hecho incluye 15 preguntas específicas para hacerle a tu médico en tu próxima consulta.'
}, {
  question: '¿Lo entenderé aunque no tenga estudios médicos?',
  answer: 'Ese es exactamente el punto del libro. Fue escrito para el latino mayor de 40 años que recibe diagnósticos sin explicaciones. Sin tecnicismos. Sin condescendencia. Con el mismo respeto intelectual que merece cualquier persona que quiere entender su propio cuerpo.'
}, {
  question: '¿Cuándo puedo empezar? ¿Es realmente inmediato?',
  answer: 'Inmediato significa inmediato. En menos de 2 minutos después de tu pago recibes el acceso. No hay envío, no hay espera, no hay instalación. Haces clic, pagas y el libro es tuyo.'
}, {
  question: '¿Mi pago está protegido?',
  answer: 'Sí. El pago se procesa a través de plataformas seguras con encriptación SSL. Tu información financiera nunca toca nuestros servidores. Es tan seguro como pagar en Amazon.'
}, {
  question: '¿Qué pasa si siento que no fue lo que esperaba?',
  answer: 'Tienes 7 días para pedir el reembolso completo sin ninguna explicación, sin formularios y sin trámites. El riesgo es completamente nuestro. Tu único riesgo real es seguir sin el mapa.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="relative bg-ivory py-[40px] md:py-[64px] px-6" data-id="element-75">
      {/* Section Separator */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-b from-[#F3EFE6] to-transparent opacity-50 pointer-events-none z-20" data-id="element-76"></div>

      <div className="max-w-[860px] mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-78">
          <p className="font-mono text-[11px] tracking-[0.15em] text-text-muted uppercase mb-6 text-center" data-id="element-79">
            PREGUNTAS FRECUENTES
          </p>
        </motion.div>

        <div className="max-w-[720px] mx-auto" data-id="element-80">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.05
        }} className="border-b border-border-light py-6" data-id="element-81">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between text-left group" aria-expanded={openIndex === index} data-id="element-82">
                <span className="font-serif font-bold text-[17px] text-text-primary pr-4 group-hover:text-cocoa transition-colors" data-id="element-83">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-text-muted flex-shrink-0 transition-transform duration-300 ease-in-out ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-84" />
              </button>

              <AnimatePresence data-id="element-85">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-86">
                    <p className="font-serif text-[16px] leading-[1.8] text-text-secondary pt-4" data-id="element-87">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}